/* eslint-disable no-unused-vars */
import React, { useContext } from 'react';
import { CotizadorContext } from '../context';
import axios from 'axios';

const useStationsData = () => {
    const [state, setState] = useContext(CotizadorContext)

    const getStations = async () => {
        const response = await axios.get('/api/kinto/one_personal_stations');
        setState(prevState => ({
            ...prevState,
            stations: response?.data
        }))
    }

    return {
        stations: state.stations,
        getStations,
    };
}

export default useStationsData;